import { request2 } from '@/utils/httpClient'
import { getAuthHeaders } from './requestHelpers'

export const loginAPI = ({ loginId, password }) => {
  return request2({
    url: '/login/userlogin',
    method: 'POST',
    data: {
      loginId,
      password
    }
  })
}

// 使用 Google 登录 code 进行登录

export const googleLoginWithCode = (code) => {
  return request2({
    url: '/login/google-login-code',
    method: 'POST',
    data: { code }
  })
}

// 获取 Google 登录跳转链接

export const fetchGoogleLoginUrl = () => {
  return request2({
    url: '/login/google-url',
    method: 'GET'
  })
}

// 修改当前账号密码

export const updatePwdAPI = ({ username, newPassword, oldPassword, email, emailVerifyCode }) => {
  return request2({
    url: '/login/updatePwd',
    method: 'POST',
    data: {
      username,
      newPassword,
      oldPassword,
      email,
      emailVerifyCode
    },
    headers: getAuthHeaders()
  })
}

// 邮箱注册

export const registerEmail = (data) => {
  return request2({
    url: '/login/register',
    method: 'POST',
    data: data
  })
}

// 验证注册信息（不创建账户）

export const validateRegister = (data) => {
  return request2({
    url: '/login/validate-register',
    method: 'POST',
    data: data
  })
}

// 获取当前用户的公司/住所 profile 信息

export const getUserProfile = () => {
  return request2({
    url: '/login/user-profile',
    method: 'GET'
  })
}

// 更新当前用户的公司/住所 profile 信息

export const updateUserProfile = (nickname, source, phone) => {
  const data = {}
  if (nickname !== undefined) data.nickname = nickname
  if (source !== undefined) data.source = source
  if (phone !== undefined) data.phone = phone
  return request2({
    url: '/login/user-profile',
    method: 'PUT',
    data
  })
}

// 完成当前用户入驻引导

export const completeUserOnboarding = (tourKey) => {
  return request2({
    url: '/login/user-onboarding/complete',
    method: 'POST',
    data: { tourKey: tourKey || 'cases' }
  })
}

// 查询当前用户是否已同意最新服务条款

export const getTermsAgreementStatus = () => {
  return request2({
    url: '/login/terms-agreement/status',
    method: 'GET'
  })
}

// 同意最新服务条款

export const acceptTermsAgreement = () => {
  return request2({
    url: '/login/terms-agreement/accept',
    method: 'POST',
    data: {}
  })
}

// 发送邮箱验证码

export const sendEmailCode = (language, toEmailAddress, familyName = '', scene = '') => {
  const data = {
    language,
    toEmailAddress
  };

  // 只在 familyName 有值时才添加到请求中
  if (familyName && familyName.trim() !== '') {
    data.familyName = familyName.trim();
  }
  // 只在 scene 有值时才添加到请求中（用于区分 register/login/reset 等场景）
  if (scene && String(scene).trim() !== '') {
    data.scene = String(scene).trim();
  }

  return request2({
    url: '/login/send-email-verify-code',
    method: 'POST',
    data: data
  })
}

// 邮箱验证码登录

export const loginEmailCode = (data) => {
  return request2({
    url: '/login/email-login',
    method: 'POST',
    data: data
  })
}

// 修改邮箱账号密码

export const updateEmailPassword = (data) => {
  return request2({
    url: '/login/forgetPassword',
    method: 'POST',
    data: data
  })
}
